if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");
        this.upsellVariantId = this.dataset.upsellVariantId;

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      async onSubmitHandler(evt) {
  evt.preventDefault();
  if (this.submitButton.getAttribute("aria-disabled") === "true") return;

  this.handleErrorMessage();

  this.submitButton.setAttribute("aria-disabled", true);
  this.submitButton.classList.add("loading");
  this.querySelector(".loading__spinner").classList.remove("hidden");

  try {
    const formData = new FormData(this.form);
    const mainId = Number(formData.get("id"));
    const mainQty = Number(formData.get("quantity") || 1);

    // Collect main item properties from formData (properties[...])
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const m = /^properties\[(.+)\]$/.exec(key);
      if (m) properties[m[1]] = value;
    }

    // Decide whether we include upsell in the same add
    let includeUpsell = false;
    if (this.upsellVariantId) {
      const cartState = await fetch(`${routes.cart_url}.js`).then(r => r.json());
      includeUpsell = cartState.item_count === 0;
    }

    const items = [];

    if (includeUpsell) {
      items.push({
        id: Number(this.upsellVariantId),
        quantity: 1,
        properties: { _upsell: "true", _upsell_type: "pdp_first_cart" },
      });
    }

    items.push({
      id: mainId,
      quantity: mainQty,
      ...(Object.keys(properties).length ? { properties } : {}),
    });

    // If you rely on sections to render drawer, request them after add
    // We'll add first, then fetch sections for the drawer in a second request
    const addResp = await fetch(`${routes.cart_add_url}.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items }),
    });

    const addData = await addResp.json();

    // If Shopify returned an error-style payload
    if (addData.status) {
      publish(PUB_SUB_EVENTS.cartError, {
        source: "product-form",
        productVariantId: formData.get("id"),
        errors: addData.errors || addData.description,
        message: addData.message,
      });
      this.handleErrorMessage(addData.description);
      this.error = true;
      return;
    }

    // Now fetch sections payload for drawer rendering (keeps your renderContents flow intact)
    let responseForDrawer = addData;
    if (this.cart) {
      const sections = this.cart.getSectionsToRender().map((section) => section.id);
      const sectionsResp = await fetch(`${routes.cart_url}?sections=${encodeURIComponent(sections.join(","))}`, {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      // Shopify returns { sections: {id: html,...}, ... } depending on endpoint
      const sectionsJson = await sectionsResp.json();
      responseForDrawer = {
        ...addData,
        sections: sectionsJson.sections || sectionsJson,
      };
    }

    // Publish internal theme event (not Shopify admin analytics, but keeps your theme consistent)
    publish(PUB_SUB_EVENTS.cartUpdate, {
      source: "product-form",
      productVariantId: formData.get("id"),
      cartData: responseForDrawer,
    });

    this.error = false;

    const quickAddModal = this.closest("quick-add-modal");
    if (quickAddModal) {
      document.body.addEventListener(
        "modalClosed",
        () => setTimeout(() => this.cart.renderContents(responseForDrawer)),
        { once: true }
      );
      quickAddModal.hide(true);
    } else if (this.cart) {
      this.cart.renderContents(responseForDrawer);
    } else {
      window.location = window.routes.cart_url;
    }
  } catch (e) {
    console.error(e);
  } finally {
    this.submitButton.classList.remove("loading");
    if (this.cart && this.cart.classList.contains("is-empty")) this.cart.classList.remove("is-empty");
    if (!this.error) this.submitButton.removeAttribute("aria-disabled");
    this.querySelector(".loading__spinner").classList.add("hidden");
  }
}

      getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append("id", this.upsellVariantId);
        upsellFormData.append("quantity", 1);

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        config.body = upsellFormData;

        return config;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
